import { useState } from 'react';
import './style/News.scss';

// Import your local images
import bitcoinImg from '../../assets/news/bitcoin-high.jpg';
import regulationImg from '../../assets/news/eu-regulation.jpg';
import Indonesiacryptotax from '../../assets/news/Indonesia-crypto-tax.jpg';
import usseccrypto from '../../assets/news/usseccrypto.jpeg';
import xdccrypto from '../../assets/news/xdccrypto.webp';
import arizonacrypto from '../../assets/news/arizonacrypto.jpg';

const News = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const newsCategories = [
    'all',
    'market',
    'blockchain',
    'regulation',
    'partnerships'
  ];

  const newsItems = [
    {
      id: 1,
      title: 'Ethereum whale wallets rise as Bitcoin whales decline — Is the altcoin rotation underway?',
      categories: ['market', 'blockchain'],
      date: '2023-10-15',
      excerpt: 'As Bitcoin’s largest holders reduce their positions, the number of Ethereum whale wallets is increasing, fuelling speculation about a possible altcoin rotation led by Ethereum...',
      image: bitcoinImg
    },
    {
      id: 2,
      title: 'Ethereum treasury sprint: ETH Strategy raises more than 12k ETH – what happens next?',
      categories: ['regulation', 'market'],
      date: '2023-10-14',
      excerpt: 'The Indonesian government plans to raise taxes on cryptocurrency transactions, effective immediately...',
      image: regulationImg
    },
    {
      id: 3,
      title: 'Indonesia set to raise crypto transaction tax for exchanges, by how much?',
      categories: ['regulation'],
      date: '2023-10-14',
      excerpt: 'European Commission proposes new framework for crypto assets...',
      image: Indonesiacryptotax
    },
    {
      id: 4,
      title: 'US SEC approves in-kind redemptions for crypto ETPs',
      categories: ['regulation'],
      date: '2023-10-14',
      excerpt: 'The U.S. SEC has approved in-kind creation and redemption for all spot Bitcoin and Ethereum ETFs...',
      image: usseccrypto
    },
    {
      id: 5,
      title: 'XDC price retraces after Binance US listing spike—here’s why the current dip is a smart entry',
      categories: ['market'],
      date: '2023-10-14',
      excerpt: 'XDC price surged 12% on Binance US listing news, then pulled back — is it a buy-the-dip opportunity?',
      image: xdccrypto
    },
    {
      id: 6,
      title: 'Arizona man at center of $13m crypto ponzi pleads guilty nearly two years after indictment',
      categories: ['regulation'],
      date: '2023-10-14',
      excerpt: 'An Arizona man pleads guilty to a $13M crypto Ponzi scheme involving fake AI bots and fake government claims.',
      image: arizonacrypto
    }
  ];

  const filteredNews =
    activeCategory === 'all'
      ? newsItems
      : newsItems.filter(item => item.categories.includes(activeCategory));

  return (
    <div className="news-page">
      <h1>Crypto News</h1>

      <div className="news-categories">
        {newsCategories.map(category => (
          <button
            key={category}
            className={activeCategory === category ? 'active' : ''}
            onClick={() => setActiveCategory(category)}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>

      <div className="news-list">
        {filteredNews.map(item => (
          <div key={item.id} className="news-card">
            <img src={item.image} alt={item.title} className="news-image" />
            <div className="news-category-badges">
              {item.categories.map(cat => (
                <span key={cat} className="news-category-badge">
                  {cat}
                </span>
              ))}
            </div>
            <h3>{item.title}</h3>
            <p className="news-date">{item.date}</p>
            <p className="news-excerpt">{item.excerpt}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
